function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#212A33",
    fillRule: "evenodd",
    d: "M17 2a3 3 0 013 3v16a1 1 0 01-1.555.832L12 18.202l-6.445 3.63A1 1 0 014 21V5a3 3 0 013-3h10zm-4.794 6.048a.464.464 0 00-.622.211l-.676 1.369-1.51.22a.464.464 0 00-.258.791l1.093 1.066-.258 1.504a.464.464 0 00.674.49l1.135-.597a.464.464 0 01.432 0l1.135.596a.464.464 0 00.674-.49l-.258-1.503 1.093-1.066a.464.464 0 00-.258-.792l-1.51-.22-.676-1.368a.464.464 0 00-.21-.21z"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-favorite.svg";